/* ============================================================
   DRT — play product-card hover videos on hover
   ------------------------------------------------------------
   Bound once at the document level via event delegation so it
   works for cards present at load AND cards injected later
   (e.g. related products, which global.js inserts via innerHTML
   and would skip any <script> placed inside the cards).
   ============================================================ */
(function () {
  if (window.drtCardVideoHoverBound) return;
  window.drtCardVideoHoverBound = true;

  // Hover is a pointer-fine interaction; skip on touch devices.
  if (!window.matchMedia('(pointer: fine)').matches) return;

  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card) return;
    var video = card.querySelector('.drt-card-video');
    if (video && video.paused) {
      video.play().catch(function () {});
    }
  });

  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    // Ignore moves that stay inside the same card.
    if (!card || card.contains(e.relatedTarget)) return;
    var video = card.querySelector('.drt-card-video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });
})();
